import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Collapsible, CollapsibleContent } from "../../../ui/collapsible";
import { isLocationMatch, cn } from "../../../../helper/utilityHelper";
import NewTag from "./NewTag";
const MultiNestedMenu = ({ subItem, subIndex, activeMultiMenu }) => {
  const locationName = useLocation().pathname;
  return (
    <Collapsible open={activeMultiMenu === subIndex}>
      <CollapsibleContent className="CollapsibleContent">
        <ul className="space-y-3 pl-1">
          {subItem?.multi_menu?.map((item, i) => (
            <li className=" first:pt-3" key={i}>
              <Link href={item.href}>
                <span
                  className={cn(
                    "text-sm flex gap-3  items-center transition-all duration-150 capitalize hover:text-primary",
                    {
                      " text-primary  ": isLocationMatch(
                        item.href,
                        locationName
                      ),
                      " text-default-600": !isLocationMatch(
                        item.href,
                        locationName
                      ),
                    }
                  )}
                >
                  <span
                    className={cn(
                      "inline-flex h-2 w-2  border border-default-500 rounded-full ",
                      {
                        "bg-primary ring-primary/30   ring-[4px]  border-primary  ":
                          isLocationMatch(item.href, locationName),
                      }
                    )}
                  ></span>
                  <span className="flex-1 flex items-center">
                    {item.title}
                    {item.isNew && <NewTag className="ml-2" />}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default MultiNestedMenu;
